import request from '@/config/axios'

export interface NotificationVO {
  id?: string | number
  shopId: string | number
  recipientId?: string | number
  recipientName?: string
  type: number // 1=入住提醒 2=退房提醒 3=清洁任务 4=维修工单 5=系统通知 6=夜审通知
  typeLabel?: string
  title: string
  content: string
  channel?: number // 1=站内信 2=短信 3=微信
  readStatus?: number // 0=未读 1=已读
  readTime?: string
  bizType?: string
  bizId?: string | number
  priority?: number // 0=普通 1=重要 2=紧急
  createTime?: string
}

export interface SendDTO {
  shopId: string | number
  recipientIds?: (string | number)[]
  type: number
  title: string
  content: string
  channel?: number
  bizType?: string
  bizId?: string | number
  priority?: number
}

// 获取通知分页
export const getNotificationPage = (params: any) => {
  return request.get({ url: '/hotel/notification/page', params })
}

// 获取通知详情
export const getNotification = (id: string | number) => {
  return request.get({ url: '/hotel/notification/get?id=' + id })
}

// 创建通知
export const createNotification = (data: NotificationVO) => {
  return request.post({ url: '/hotel/notification/create', data })
}

// 更新通知
export const updateNotification = (data: NotificationVO) => {
  return request.put({ url: '/hotel/notification/update', data })
}

// 删除通知
export const deleteNotification = (id: string | number) => {
  return request.delete({ url: '/hotel/notification/delete?id=' + id })
}

// 发送通知
export const sendNotification = (data: SendDTO) => {
  return request.post({ url: '/hotel/notification/send', data })
}

// 标记为已读
export const markAsRead = (id: string | number) => {
  return request.put({ url: '/hotel/notification/mark-read?id=' + id })
}

// 全部标记为已读
export const markAllAsRead = (recipientId: string | number, shopId?: string | number) => {
  return request.put({ url: '/hotel/notification/mark-all-read', params: { recipientId, shopId } })
}

// 获取未读数量
export const getUnreadCount = (recipientId: string | number, shopId?: string | number) => {
  return request.get({ url: '/hotel/notification/unread-count', params: { recipientId, shopId } })
}

// 获取通知类型列表
export const getTypeList = () => {
  return request.get({ url: '/hotel/notification/type-list' })
}
